module.exports = __webpack_public_path__ + "img/vendor-icon-fashion.1e48ecbc.png";